import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import TaiXiuHeaderNav from "../../components/TaiXiuHeaderNav";

function SetTX() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState(null);
    const [total, setTotal] = useState(null);
    
    const [chimMoiList, setChimMoiList] = useState([]);

    const [selectedDice, setSelectedDice] = useState([]);
    const [kq, setKQ] = useState("");

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { "1": "CHẴN", "2": "LẺ", "3": "TÀI", "4": "XỈU" };
        return stateStr.split(" ").map(s => map[s] || s).join(", ");
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data);
        }).catch(() => setList30(null));

        axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                setBet(res.data.data);
            }
        });
    };
    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchChimMoiList = () => {
        const codeChimMoi = `tx45ssanh${SANH_ID}`;
        axios.get(`${process.env.REACT_APP_API_URL}/auth/chimmoi?code=${codeChimMoi}`)
            .then(res => {
                if (res.data && res.data.data) {
                    setChimMoiList(res.data.data);
                }
            })
            .catch(err => {
                console.log("Không lấy được danh sách chim mồi", err);
                setChimMoiList([]);
            });
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                setBet(res.data.data);
                setDulieunhap(new Date(res.data.data.createdAt));
                setStart(true);
            }
        }).catch((err) => console.log("Chờ phiên mới..."));

        axios
            .get(`${process.env.REACT_APP_API_URL}/TX45s/getallbet?sanh=${SANH_ID}`, {})
            .then((res) => {
                if (res.data && res.data.data) setTotal(res.data.data);
            })
            .catch(() => setTotal(null));

        reloadHistorySilently();
        fetchCurrentBets(); 
        fetchChimMoiList();
    };

    useEffect(() => {
        setBet(null);
        setCurrent(null);
        fetchNewSessionAdmin();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 45 - diffInSeconds; // Game 45s

            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);

        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        const pollInterval = setInterval(() => {
            fetchCurrentBets();
        }, 2000);

        return () => clearInterval(pollInterval);
    }, [SANH_ID]);

    const handleQuickSubmit = (resultString) => {
        if (!bet) return;
        const formData = {
            id_bet: bet._id,
            result: resultString,
            sanh: SANH_ID
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/TX45s/update`, formData)
            .then((res) => {
                swal(t('success'), `Đã set kết quả thành công!`, "success");
                reloadHistorySilently();
            })
            .catch((res) => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    const handleDiceClick = (num) => {
        if (selectedDice.length < 3) {
            setSelectedDice([...selectedDice, num]);
        }
    };

    const clearDice = () => {
        setSelectedDice([]);
    };

    const handleDiceSubmit = () => {
        if (!bet) return;
        if (selectedDice.length !== 3) {
            swal("Lỗi", "Vui lòng chọn đủ 3 viên xúc xắc!", "warning");
            return;
        }
        const resultString = selectedDice.join("");
        handleQuickSubmit(resultString);
        setSelectedDice([]);
    };

    const handleManualSubmit = (e) => {
        e.preventDefault();
        if (!bet || !kq) return;

        const digits = kq.replace(/[^1-6]/g, '');
        if (digits.length !== 3) {
            swal("Lỗi", "Vui lòng nhập đúng 3 số từ 1 đến 6 (VD: 123)", "warning");
            return;
        }

        handleQuickSubmit(digits);
        setKQ("");
    };

    function thongke(num) {
        if (current && current.length > 0) {
            const countTable = {};
            for (let i = 1; i <= 4; i++) {
                countTable[i] = { count: 0, totalMoney: 0 };
            }
            current.forEach((item) => {
                const money = item.money;
                const states = item.state.split(" ").map(Number);
                const length = states.length;

                states.forEach((state) => {
                    if (state >= 1 && state <= 4) {
                        countTable[state].count++;
                        countTable[state].totalMoney += money / length;
                    }
                });
            });
            return Math.floor(Number(countTable[num].totalMoney || 0) / 1000).toLocaleString("vi-VN");
        } else {
            return 0;
        }
    }

    const sumDice = selectedDice.reduce((a, b) => a + b, 0);
    const txLabel = selectedDice.length === 3 ? (sumDice > 10 ? "TÀI" : "XỈU") : "...";
    const clLabel = selectedDice.length === 3 ? (sumDice % 2 === 0 ? "CHẴN" : "LẺ") : "...";
    const txColor = sumDice > 10 ? "red" : "black";

    const currentSessionData = list30?.find(item => item.id_bet === bet?.id_bet);
    const displayResult = currentSessionData?.result || bet?.result;

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {profile?.permission?.set == 1 ? (
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 1
                            }}>
                            <Container maxWidth={false}>
                                <TaiXiuHeaderNav currentMode="tx45s" currentSanh={SANH_ID} />

                                <div className="container_set">SẢNH {SANH_ID} - TX 45s</div>

                                <div className="cycle_bet">
                                    {bet ? (
                                        <span style={{ color: "black" }} className="info_bet">
                                            {t('session')} {bet.id_bet}
                                        </span>
                                    ) : (
                                        <span>{t('waiting')}</span>
                                    )}
                                    <div style={{ color: "black" }} className="count">
                                        00 : {second < 10 ? "0" : ""}
                                        {second >= 0 ? second : 0}
                                    </div>
                                </div>
                                <div className="form_set"></div>

                                <div className="current_bet" style={{ paddingBottom: '10px' }}>
                                    <div className="current_bet_head">
                                        <div>{t('double')} (Chẵn)</div>
                                        <div>{t('single')} (Lẻ)</div>
                                        <div>{t('over')} (Tài)</div>
                                        <div>{t('under')} (Xỉu)</div>
                                    </div>

                                    <div className="current_bet_body">
                                        <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(1)}</div>
                                        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(2)}</div>
                                        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(3)}</div>
                                        <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(4)}</div>
                                    </div>

                                    <div className="current_bet_body" style={{ marginTop: '10px', alignItems: 'center' }}>
                                        <div>
                                            <Button variant="contained" color="success" size="small" onClick={() => handleQuickSubmit("224")} title="Set Chẵn (2 2 4 = 8đ)">CHẴN</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="secondary" size="small" onClick={() => handleQuickSubmit("122")} title="Set Lẻ (1 2 2 = 5đ)">LẺ</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="error" size="small" onClick={() => handleQuickSubmit("445")} title="Set Tài (4 4 5 = 13đ)">TÀI</Button>
                                        </div>
                                        <div>
                                            <Button variant="contained" color="info" size="small" onClick={() => handleQuickSubmit("123")} title="Set Xỉu (1 2 3 = 6đ)">XỈU</Button>
                                        </div>
                                    </div>
                                </div>

                                <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1, boxShadow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div style={{ color: "black", marginBottom: '10px', textAlign: 'center' }} className="result_admin_choose">
                                        {t('result_recent')} (Kết quả hiện tại):{" "}
                                        {bet ? (
                                            <span style={{ fontWeight: "900", color: "red", fontSize: '20px' }}>
                                                {displayResult && displayResult.trim() !== "" ? displayResult : "Chưa có"}
                                            </span>
                                        ) : (
                                            <span>{t('waiting')}</span>
                                        )}
                                    </div>
                                    <h2 style={{ marginBottom: '15px' }}>CHỌN 3 VIÊN XÚC XẮC</h2>

                                    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {[1, 2, 3, 4, 5, 6].map(num => (
                                            <Button
                                                key={num}
                                                variant="outlined"
                                                onClick={() => handleDiceClick(num)}
                                                sx={{ fontSize: '20px', minWidth: '50px', height: '50px', fontWeight: 'bold' }}
                                                disabled={selectedDice.length >= 3}
                                            >
                                                {num}
                                            </Button>
                                        ))}
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2, height: '60px' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Đã chọn:</div>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            {[0, 1, 2].map(idx => (
                                                <div key={idx} style={{
                                                    width: '50px', height: '50px',
                                                    border: '2px dashed #ccc',
                                                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                    fontSize: '24px', fontWeight: 'bold', color: '#1976d2',
                                                    borderRadius: '8px'
                                                }}>
                                                    {selectedDice[idx] || ""}
                                                </div>
                                            ))}
                                        </Box>

                                        {selectedDice.length === 3 && (
                                            <div style={{ marginLeft: '10px', fontSize: '18px' }}>
                                                = <b>{sumDice}</b> điểm (<span style={{ color: txColor, fontWeight: 'bold' }}>{txLabel}</span> / <span style={{ color: sumDice % 2 === 0 ? 'blue' : 'red', fontWeight: 'bold' }}>{clLabel}</span>)
                                            </div>
                                        )}
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <Button variant="contained" color="error" onClick={clearDice} disabled={selectedDice.length === 0}>
                                            XÓA LÀM LẠI
                                        </Button>
                                        <Button variant="contained" color="success" onClick={handleDiceSubmit} disabled={selectedDice.length !== 3}>
                                            SET KẾT QUẢ NÀY
                                        </Button>
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1, boxShadow: 1 }}>
                                    <form onSubmit={handleManualSubmit} style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Hoặc {t('edit_result')} (Nhập tay): </span>
                                        <input
                                            value={kq}
                                            onChange={(e) => setKQ(e.target.value)}
                                            type="text"
                                            placeholder="VD: 123"
                                            style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', width: '200px' }}
                                        />
                                        <Button type="submit" variant="contained" color="primary">{t('submit')}</Button>

                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => window.location.reload(true)}
                                        >
                                            {t('refresh')}
                                        </Button>
                                    </form>
                                </Box>

                                <Paper elevation={3} sx={{ mt: 4, mb: 4, borderRadius: 2, overflow: 'hidden' }}>
                                   
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: '#fff3e0' }}>
                                                <TableCell style={{ fontWeight: 'bold', width: '10%' }}>STT</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '20%' }}>ID User</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '40%' }}>Tài Khoản</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '30%' }}>Mã Lệnh Đang Ép</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {chimMoiList && chimMoiList.length > 0 ? (
                                                chimMoiList.map((item, idx) => (
                                                    <TableRow key={idx} hover>
                                                        <TableCell style={{ fontWeight: 'bold' }}>{idx + 1}</TableCell>
                                                        <TableCell>{item.iduser}</TableCell>
                                                        <TableCell style={{ color: '#1976d2', fontWeight: 'bold' }}>{item.username}</TableCell>
                                                        <TableCell style={{ color: 'red', fontWeight: 'bold' }}>{item.win}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                    <TableCell colSpan={4}>Không có Chim Mồi nào được cài ở sảnh này.</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Paper>

                                <div className="form_set" style={{ marginTop: '20px' }}>
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold', width: '10%' }}>ID</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '25%' }}>{t('username')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '20%' }}>{t('selected')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '20%' }}>Số điểm</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', width: '25%' }}>{t('time')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {current && current.length > 0 ? (
                                                    current.map((item, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell>{item?.user?.iduser}</TableCell>
                                                            <TableCell>{item?.user?.username}</TableCell>
                                                            <TableCell>
                                                                <span style={{ fontWeight: 'bold', color: '#e53935' }}>
                                                                    {getBetLabel(item.state)}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>
                                                                <span style={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                                                    {Math.floor(Number(item.money || 0) / 1000).toLocaleString("vi-VN")}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>{formatDate(new Date(item.createdAt))}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                        <TableCell colSpan={5}>{t('no_player')}</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>

                                <div className="form_set" style={{ marginTop: '20px' }}>
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }}>STT</TableCell>
                                                    <TableCell>{t('session')}</TableCell>
                                                    <TableCell>{t('result')}</TableCell>
                                                    <TableCell>{t('update')} (Sửa lịch sử)</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{t('time')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {list30 ? list30
                                                    .filter((item) => {
                                                        if (!bet || !bet.id_bet) return true;
                                                        return Number(item.id_bet) >= Number(bet.id_bet);
                                                    })
                                                    .sort((a, b) => Number(a.id_bet) - Number(b.id_bet))
                                                    .map((item, idx) => {
                                                        const isCurrent = item.id_bet === bet?.id_bet;
                                                        return (
                                                            <TableRow
                                                                key={item._id || idx}
                                                                sx={{ bgcolor: isCurrent ? '#fff9c4' : 'inherit' }}
                                                            >
                                                                <TableCell style={{ fontWeight: 'bold', color: '#1976d2' }}>
                                                                    {idx + 1}
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: isCurrent ? 'bold' : 'normal' }}>
                                                                    {item?.id_bet}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <span style={{ fontWeight: isCurrent ? 'bold' : 'normal', color: isCurrent ? 'red' : 'inherit' }}>
                                                                        {item.result}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <form
                                                                        style={{ display: 'flex', gap: '5px' }}
                                                                        onSubmit={(e) => {
                                                                            e.preventDefault();
                                                                            const rawVal = e.target.result.value;
                                                                            if (!rawVal) return;

                                                                            const digits = String(rawVal).replace(/[^1-6]/g, '');
                                                                            if (digits.length !== 3) {
                                                                                swal("Lỗi", "Vui lòng nhập đúng 3 số từ 1 đến 6 (VD: 123)", "warning");
                                                                                return;
                                                                            }

                                                                            const formData = {
                                                                                id_bet: item._id,
                                                                                result: digits, 
                                                                                sanh: SANH_ID
                                                                            };

                                                                            axios
                                                                                .post(`${process.env.REACT_APP_API_URL}/TX45s/update`, formData)
                                                                                .then((res) => {
                                                                                    swal(t('success'), `Đã cập nhật phiên ${item.id_bet}`, "success");
                                                                                    e.target.reset();
                                                                                    reloadHistorySilently();
                                                                                })
                                                                                .catch(() => swal(t('error'), "Lỗi kết nối", "error"));
                                                                        }}>
                                                                        <input
                                                                            name="result"
                                                                            type="text"
                                                                            placeholder="VD: 123"
                                                                            style={{ width: '70px', padding: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                                                                        />
                                                                        <button className="btn-admin-3" style={{ padding: '5px 10px', cursor: 'pointer' }}>
                                                                            {t('submit')}
                                                                        </button>
                                                                    </form>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: "center" }}>
                                                                    {formatDate(new Date(item.createdAt))}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                    : null}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>
                            </Container>
                        </Box>
                    ) : (
                        <div>{t('not_permission')}</div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default SetTX;
